module.exports = __webpack_public_path__ + "static/media/coding.33a18e02.svg";